(function () {
/**
 * Base JS
 */ // Assuming site header is sticky, add a class to indicate when it's "stuck"
const $44ae6d9db4eaca0f$var$siteHeader = document.querySelector(".site-header");
let $44ae6d9db4eaca0f$var$siteHeaderScrollTimeoutId = 0;
window.addEventListener("scroll", ()=>{
    clearTimeout($44ae6d9db4eaca0f$var$siteHeaderScrollTimeoutId);
    $44ae6d9db4eaca0f$var$siteHeaderScrollTimeoutId = setTimeout(()=>{
        $44ae6d9db4eaca0f$var$siteHeader.classList.toggle("site-header--is-pinned", window.scrollY > 0);
    }, 25);
});
// When clicking on a primary nav link, close the mobile menu
// (because on this site, many of the nav links are anchor links)
// Also, if it's the homepage, trigger the nav pinned style as soon as we click a link
const $44ae6d9db4eaca0f$var$navStatusElement = document.querySelector(".site-header__mobile-nav-status");
const $44ae6d9db4eaca0f$var$siteNavlinks = document.querySelector(".site-header__nav-links");
$44ae6d9db4eaca0f$var$siteNavlinks.addEventListener("click", (e)=>{
    $44ae6d9db4eaca0f$var$navStatusElement.checked = false;
    window.location.pathname == "/" && $44ae6d9db4eaca0f$var$siteHeader.classList.add("site-header--is-pinned");
});

})();
//# sourceMappingURL=index.js.map
